import React from "react";
import { Link, useInRouterContext } from "react-router-dom";
import { NoticeBox } from "../ui";
import { BILLING_PATH, lockReasonText, subscriptionText } from "../../access/subscription";
import "./SubscriptionLockNotice.css";

/*
  The one explanation shown wherever an operational action is locked because the store has no active subscription: why, and a link
  to the existing subscription page. It never replaces the page (the page stays visible and readable); it sits next to the locked
  action. `reason` comes from useOperationalAccess().check(...).reason.
*/
export function BillingLink({ lang, className = "" }) {
  const inRouter = useInRouterContext();
  const label = subscriptionText(lang).action;
  return inRouter ? (
    <Link className={`subscription-lock-link ${className}`} to={BILLING_PATH}>{label}</Link>
  ) : (
    <a className={`subscription-lock-link ${className}`} href={BILLING_PATH}>{label}</a>
  );
}

export default function SubscriptionLockNotice({ reason, lang = "ar", className = "", title }) {
  const text = subscriptionText(lang);
  const message = reason === "role_pending" ? text.pendingRole : lockReasonText(reason, lang);
  return (
    <NoticeBox variant="info" size="sm" className={`subscription-lock-notice ${className}`} title={title}>
      <span data-testid="subscription-lock-notice" dir={lang === "en" ? "ltr" : "rtl"}>
        {message}{" "}
        {reason !== "role_pending" && <BillingLink lang={lang} />}
      </span>
    </NoticeBox>
  );
}
